export default {
  en: {
    currency: {
      style: "currency",
      currency: "USD",
    },
  },
};
